<template>
  <div :class="$style.wrapper">
    <template v-if="!isError">
      <div :class="$style.canvasWrapper" :style="{ width: `${width}px`, height: `${height}px` }">
        <canvas width="300" height="300" ref="canvas" id='jeeFaceFilterCanvas'></canvas>
        <canvas width="300" height="300" id='threeCanvas'></canvas>
      </div>
    </template>
    <template v-else>
      <div :class="$style.slot">
        <slot></slot>
      </div>
    </template>
    <div :class="[$style.button, $slots.additionalBtn && $style.has_additional]" :style="{ width: `${width}px`, }">
      <slot name="additionalBtn"></slot>
      <Button @click="handleShare" :class="$style.buttonShare" outline>
        <svg :style="{ width: '3.9rem', marginTop: $mq === 'sm' ? '0.3rem' : '1rem' }" width="39" height="23" viewBox="0 0 39 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.72946 0H1.46286C0.243823 0 0 0.569916 0 1.19818C0 2.32046 1.44648 7.88634 6.73505 15.2477C10.2608 20.2749 15.2282 23 19.7484 23C22.4605 23 22.796 22.3947 22.796 21.3522V17.5526C22.796 16.3421 23.0529 16.1005 23.9116 16.1005C24.5445 16.1005 25.6293 16.4147 28.1607 18.8386C31.0536 21.7113 31.5305 23 33.1577 23H37.4243C38.6434 23 39.2529 22.3947 38.9013 21.2003C38.5165 20.0099 37.1353 18.2826 35.3025 16.2352C34.308 15.0681 32.8164 13.8114 32.3644 13.1829C31.7316 12.375 31.9123 12.0158 32.3644 11.2977C32.3644 11.2977 37.5626 4.02609 38.105 1.55746C38.3762 0.659616 38.105 0 36.8148 0H32.5482C31.4634 0 30.9632 0.569916 30.6919 1.19818C30.6919 1.19818 28.5223 6.44993 25.4486 9.86131C24.4541 10.8487 24.0021 11.163 23.4596 11.163C23.1884 11.163 22.7959 10.8487 22.7959 9.95113V1.55746C22.7959 0.480095 22.4811 0 21.5769 0H14.8722C14.1943 0 13.7865 0.499947 13.7865 0.973868C13.7865 1.99507 15.3233 2.23064 15.4818 5.10334V11.3426C15.4818 12.7105 15.2329 12.9586 14.6906 12.9586C13.2441 12.9586 9.72574 7.68333 7.639 1.64716C7.23011 0.473922 6.81988 0 5.72946 0Z" fill="white"/>
        </svg>
        <span>Поделиться</span>
      </Button>
      <Button @click="handleDownload" :class="$style.buttonShare" outline>
        <svg :style="{ width: '3.6rem' }" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M35.1 5.22L31.32 0.36C31.14 0.18 30.78 0 30.42 0H5.58C5.22 0 4.86 0.18 4.68 0.36L0.9 5.22C0.36 5.76 0 6.3 0 7.02V32.4C0 34.38 1.62 36 3.6 36H32.4C34.38 36 36 34.38 36 32.4V25.2V7.02C36 6.3 35.64 5.76 35.1 5.22ZM18 28.8L9 19.8H14.4V12.6H21.6V19.8H27L18 28.8ZM30.6 5.4H5.4L6.3 3.6H29.7L30.6 5.4Z" fill="white"/>
        </svg>
        <span>Скачать</span>
      </Button>
      <Button @click="success">Продолжить</Button>
    </div>
  </div>
</template>
<script>
/* eslint-disable import/first,camelcase,no-use-before-define */
import * as THREE from 'three'

import download from '@/utils/download'

import Button from '@/components/Button/Button'

import JEEFACEFILTERAPI from './jeeliz/jeelizFaceFilter.module'

window.THREE = THREE

import JeelizResizer from './jeeliz/helpers/JeelizResizer'
import JeelizThreeHelper from './jeeliz/helpers/JeelizThreeHelper'

const loadImage = src => new Promise((resolve) => {
  const img = new Image()
  img.onload = () => resolve(img)
  img.src = src
})

export default {
  name: 'camera',
  props: ['head', 'eyes', 'mouth', 'active'],
  components: { Button },
  data() {
    return {
      isError: false,
      width: 0,
      height: 0,
      inited: false,
      THREECAMERA: null,
    }
  },
  methods: {
    async getImage() {
      return new Promise(async (resolve) => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (!this.isError) {
          const p = Array.from(['jeeFaceFilterCanvas', 'threeCanvas']).map(async (cnvId) => {
            const cnv = document.getElementById(cnvId)

            canvas.width = cnv.width
            canvas.height = cnv.height

            return ctx.drawImage(await loadImage(cnv.toDataURL()), 0, 0)
          })
          await Promise.all(p)
        } else {
          const { head, eyes, mouth } = this

          canvas.width = 616
          canvas.height = 712

          ctx.drawImage(await loadImage(require('./assets/face.png')), 0, 0, 616, 712)
          if (head) ctx.drawImage(await loadImage(head.png), 0, 0, 616, 712)
          if (eyes) ctx.drawImage(await loadImage(eyes.png), 0, 0, 616, 712)
          if (mouth) ctx.drawImage(await loadImage(mouth.png), 0, 0, 616, 712)
        }

        setTimeout(() => {
          resolve(canvas.toDataURL())
        }, 500)
      })
    },
    async handleShare() {
      const res = await this.getImage()

      this.$vk.share({ image: res })
    },
    async handleDownload() {
      const res = await this.getImage()

      download(res, 'face.png', 'image/png')
    },

    // face filter stuff
    detect_callback(faceIndex, isDetected) {
      if (isDetected) {
        console.log('INFO in detect_callback(): DETECTED')
      } else {
        console.log('INFO in detect_callback(): LOST')
      }
    },
    init_threeFace() {
      const cubes = [this.head, this.eyes, this.mouth]
      cubes.forEach((item) => {
        if (item) {
          const cubeGeometry = new THREE.PlaneGeometry(2.5, 2.89, 32)
          const cubeMaterial = new THREE.MeshBasicMaterial({
            map: new THREE.TextureLoader().load(item.png),
          })

          cubeMaterial.transparent = true

          const threeCube = new THREE.Mesh(cubeGeometry, cubeMaterial)
          threeCube.frustumCulled = false
          threeCube.position.y = 0.5
          // threeCube.position.z = index * 1
          threeCube.scale.set(1.2, 1.2, 1.2)

          this.threeStuffs.faceObject.add(threeCube)
        }
      })
    },
    init_threeScene(spec) {
      spec.threeCanvasId = 'threeCanvas' // enable 2 canvas mode
      this.threeStuffs = JeelizThreeHelper.init(spec, this.detect_callback)

      this.init_threeFace()

      this.THREECAMERA = JeelizThreeHelper.create_camera()
    },
    init_faceFilter() {
      JEEFACEFILTERAPI.init({
        canvasId: 'jeeFaceFilterCanvas',
        NNCPath: '/neuralNets/NN_LIGHT_0.json', // This neural network model has learnt 4 expressions
        videoSettings: {
          idealWidth: 800,
          idealHeight: 600,
        },
        maxFacesDetected: 1,
        callbackReady: (errCode, spec) => {
          if (errCode) {
            console.log('AN ERROR HAPPENS. ERR =', errCode)
            this.isError = true
            return
          }

          console.log(JEEFACEFILTERAPI)
          console.log('INFO: JEEFACEFILTERAPI IS READY')
          this.init_threeScene(spec)
        },

        // called at each render iteration (drawing loop):
        callbackTrack: (detectState) => {
          JeelizThreeHelper.render(detectState, this.THREECAMERA)
        },
      }) // end JEEFACEFILTERAPI.init call
    },
    init_main() {
      return new Promise((resolve) => {
        JeelizResizer.size_canvas({
          canvasId: 'jeeFaceFilterCanvas',
          callback: (isError, bestVideoSettings) => {
            const { width, height } = this.$refs.canvas.getBoundingClientRect()
            this.width = width
            this.height = height
            this.init_faceFilter(bestVideoSettings)

            resolve()
          },
        })
      })
    },
    async success() {
      const image = await this.getImage()
      this.$emit('success', image)
    },
  },
  created() {
    this.threeObjects = {}
  },
  beforeDestroy() {
    JEEFACEFILTERAPI.destroy()
  },

  watch: {
    async active(active) {
      if (active) {
        if (!this.inited) {
          await this.init_main()
          this.inited = true
        } else {
          this.init_threeFace()
          JEEFACEFILTERAPI.toggle_pause()
        }
      } else {
        JEEFACEFILTERAPI.toggle_pause()
        // eslint-disable-next-line prefer-spread
        this.threeStuffs.faceObject.remove.apply(this.threeStuffs.faceObject, this.threeStuffs.faceObject.children)
      }
    },
  },
}
</script>
<style lang="scss" module>
.wrapper{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media #{$m-mobile} {
    margin-top: 2rem;
    height: auto;
  }

  canvas {
    //max-height: 70%;
    border-radius: 2.5rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-height: 70vh;
  }
}
.canvasWrapper {
  position: relative;
  overflow: hidden;
}

.button {
  margin-top: 4rem;
  display: flex;
  min-width: 28rem * 2 + 2rem;
  &.has_additional{
    min-width: 28rem * 3 + 4rem;
  }

  @media #{$m-mobile} {
    margin-top: 2rem;
    min-width: 14rem * 2 + 2rem;
    &.has_additional{
      min-width: 14rem * 3 + 4rem;
    }
  }

  & > * {
    flex: 1;
    width: 50%;

    & + * {
      margin-left: 2rem;
    }

    @media #{$m-mobile} {
      flex: none;
      width: auto;
      min-width: 10rem
    }
  }
}

.buttonShare {
  min-width: 10.4rem;
  width: 10.4rem;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1;
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;

  svg {
    height: auto;
  }

  span {
    display: block;
    margin-top: 1.5rem;
  }

  @media #{$m-mobile} {
    padding: 0.4rem 0;
    font-size: 1rem;

    span {
      margin-top: 0.4rem;
    }
  }
}

.slot {
  & > div {
    position: static;
    transform: translateZ(0);

    @media #{$m-mobile} {
      margin-top: -4rem;
    }
  }

  & + .button {
    margin-top: -6rem;
    position: relative;
    z-index: 5;
  }

  @media #{$m-mobile} {
    width: 40rem;
    height: 40rem;

    & > div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
